import type { FileUIPart, UIMessage } from 'ai';

/** The owned source is display context; only poster files reach model vision. */
export function gallerySourceMessage(
  text: string,
  files: FileUIPart[] | undefined,
  context: { entityType: string; entityId: string } | null
): { parts: UIMessage['parts'] } {
  return {
    parts: [
      ...(context?.entityType === 'video'
        ? sourceVideoParts([
            { type: 'source-video', videoId: context.entityId },
          ])
        : []),
      ...(files ?? []),
      { type: 'text', text },
    ],
  };
}

export function sourceVideoParts(attachments: unknown): UIMessage['parts'] {
  if (!Array.isArray(attachments)) return [];
  for (const value of attachments) {
    if (value?.type === 'source-video' && validId(value.videoId)) {
      return [{ type: 'data-source-video', data: { videoId: value.videoId } }];
    }
  }
  return [];
}

export function sourceVideoIdFromParts(
  parts: UIMessage['parts']
): string | null {
  for (const part of parts) {
    if (part.type !== 'data-source-video') continue;
    const data = part.data as { videoId?: unknown } | null;
    if (data && validId(data.videoId)) return data.videoId;
  }
  return null;
}

function validId(value: unknown): value is string {
  return typeof value === 'string' && /^[a-zA-Z0-9_-]{1,128}$/.test(value);
}
